import { useQuery } from 'react-query'

import {
  request,
  type ApiResponse,
  HTTPMethod,
} from '../../../global/api/legacyApi'

import { type LiveScheduleDTO } from './liveSchedule'

const SCHEDULE_LIVE_KEY = 'schedule_live_key'

const useSchedule = (liveId?: number, token?: string) => {
  return useQuery({
    queryKey: [SCHEDULE_LIVE_KEY, liveId],
    queryFn: async () => {
      if (!liveId || !token) return null

      const { data } = await request<ApiResponse<LiveScheduleDTO[]>>({
        url: '/api/2/live/schedule/list',
        method: HTTPMethod.POST,
        data: {
          live_id: liveId,
          token,
        },
      })

      return data.find((liveSchedule) => +liveSchedule.live_id === liveId)
    },
    cacheTime: Infinity,
    staleTime: Infinity,
  })
}

export { useSchedule }
